import {memo} from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import getFacebookSocialLoginWpUser from '../../../actions/getFacebookSocialLoginWpUser';
import {useDispatch} from 'react-redux';

const SmileFacebookLogin = memo(({text}) => {
    const dispatch = useDispatch();

    const responseFacebook = (response) => {
        dispatch( getFacebookSocialLoginWpUser( response ) )
    }

    return (
        <FacebookLogin
            appId="483617562650433"
            callback={responseFacebook}
            render={renderProps => (
                <button onClick={renderProps.onClick} className='cursor button Facebook' disabled={renderProps.disabled}>{text}</button>
            )}
        />
    );
});

export default SmileFacebookLogin;